// document.querySelectorAll('.radio-button-group').forEach((group) => {
//   const msg = group.querySelector('[data-fv-not-empty___message]')?.dataset.fvNotEmpty___message;
//   if (msg) {
//     group
//       .querySelector('.radio-button-group__list')
//       .insertAdjacentHTML('afterend', `<div class="radio-button-group__error">${msg}</div>`);
//   }
// });
